import { Box, styled } from "@mui/material";

export const ImageUploadTeaser = styled(Box)({
    backgroundColor: "var(--community-color-transparent-black-05)",
    flex: 1,
    aspectRatio: "1",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "8px",
});

export const ImageItemContainer = styled(Box)({
    flex: 1,
    marginRight: "8px",
    aspectRatio: "1",
    borderRadius: "4px",
    position: "relative",
});

export const ImageItemPreview = styled("div")<{ image?: string }>(
    ({ image }) => ({
        height: "100%",
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "var(--community-color-transparent-black-05)",
        backgroundImage: `url(${image})`,
        borderRadius: "4px",
        marginRight: "8px",
    }),
);

export const SortableListContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    div: {
        flex: "1",
    },
});

export const TeaserImagesContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
});
